import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { cpf } from 'cpf-cnpj-validator';
import { Observable } from 'rxjs';
import { CadastroService } from 'src/app/cadastro/cadastro.service';
import { ClientePreLogin } from 'src/app/shared/models/cliente-pre-login-model';
import { ToastService } from 'src/app/shared/toast';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-step-pre-login',
  templateUrl: './step-pre-login.component.html',
  styleUrls: ['./step-pre-login.component.scss']
})
export class StepPreLoginSenhaComponent {

  isCasasBahia = location.href.indexOf('casasbahia') > 0 || location.href.indexOf('-cb') > 0;
  respostaRecaptcha: string | null;
  isMinorThanTablet: Observable<BreakpointState> = this.breakpointObserver.observe('(max-width: 1024px)');
  phonePatternRegex = /^\(?(?:[14689][1-9]|2[12478]|3[1234578]|5[1345]|7[134579])\)? ?(?:[2-8]|9[1-9])[0-9]{3}\-?[0-9]{4}$/;
  fieldsWithFocus = [];

  @Input()
  loading = false;

  @Input()
  clientePreLogin = new ClientePreLogin();

  @Output()
  continuar: EventEmitter<ClientePreLogin> = new EventEmitter<ClientePreLogin>();

  @ViewChild('form') form: NgForm;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private cadastroService: CadastroService,
    private toastService: ToastService,
  ) { }

  handleContinuar(e) {
    if (e) {
      e.preventDefault()
    }

    if (this.loading || !this.clientePreLogin.cpf || !this.clientePreLogin.telefone) {
      return;
    }

    const isPhoneValid = this.phonePatternRegex.test(this.clientePreLogin?.telefone);
    const isDocumentValid = cpf.isValid(this.clientePreLogin?.cpf);
    sessionStorage.setItem("preCpf", this.clientePreLogin.cpf);
    const isFormValid = isPhoneValid && isDocumentValid;

    if (!isFormValid || !this.isRecaptchaPreenchido) {
      this.setAllFieldsTouched();
      return;
    }

    if (this.isRecaptchaPreenchido) {
      this.continuar.emit(this.clientePreLogin);
    }
  }

  private setAllFieldsTouched() {
    Object.keys(this.form.controls).forEach(field => this.form.form.get(field).markAsTouched({ onlySelf: true }));
  }

  resolverRecaptcha(respostaRecaptcha: string): void {
    this.cadastroService.saveRecaptcha(respostaRecaptcha);
    this.respostaRecaptcha = respostaRecaptcha;
  }

  get isRecaptchaPreenchido(): boolean {
    if (this.isRecaptchaObrigatorio) {
      return !!this.respostaRecaptcha;
    }

    return true;
  }

  get isRecaptchaObrigatorio(): boolean {
    // return environment.production && !this.isHlg;
    return false;
  }

  get isHlg() {
    return location.href.indexOf('-hlg-') > 0;
  }

  setFocus(fieldname: string) {
    this.fieldsWithFocus.push(fieldname);
  }

  removeFocus(fieldname: string) {
    this.fieldsWithFocus = this.fieldsWithFocus.filter((field) => field !== fieldname);
  }

  hasFocus(fieldname: string) {
    return this.fieldsWithFocus.includes(fieldname);
  }

  clearField(control: any, fieldName: string) {
    control.setValue('');
    this.removeFocus(fieldName);
  }

  gotToSignIn(): void {
    sessionStorage.setItem("preCpf", this.clientePreLogin.cpf);
    this.router.navigate(['/cadastro'], { queryParamsHandling: 'preserve' });
  }

}
